import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { COLORS } from '../constants';
import { FAQS } from '../data/faqs';
import Button from '../components/Button';
import SectionHeading from '../components/SectionHeading';
import { Helmet } from 'react-helmet-async';


const FAQPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  return (
    <section className="py-20 min-h-screen" style={{ backgroundColor: COLORS.lightSurface }}>
      <SectionHeading title="Knowledge Center" subtitle="Common inquiries about our electric technology." />
      <div className="container mx-auto px-6 max-w-3xl">
        <div className="space-y-4">
          {FAQS.map((faq, index) => (
            <motion.div key={index} className="rounded-2xl overflow-hidden border border-[#E0D8C8] bg-white shadow-md">
              <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="w-full p-6 flex items-center justify-between text-left">
                <span className="text-xl font-bold" style={{ color: COLORS.secondaryBg }}>{faq.question}</span>
                <motion.div animate={{ rotate: activeIndex === index ? 180 : 0 }} style={{ color: COLORS.accent }}><ChevronDown size={28} /></motion.div>
              </button>
              <AnimatePresence>
                {activeIndex === index && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}>
                    <div className="px-6 pb-6 pt-2 ml-4">
                      <p className="text-lg leading-relaxed border-l-4 pl-6 font-medium" style={{ color: COLORS.textPrimary, borderColor: COLORS.accent }}>{faq.answer}</p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQPage;